jQuery(document).ready(function(jQuery) {
  setTimeout(function(){ 
    jQuery(".ga-product a").removeAttr("target");
  }, 2000);

  jQuery("#mobileNavBar .search-toggle").click(function(){
    jQuery(".mobile-header-search").toggleClass("active");  
  });
  jQuery("#mobileNavBar .menu-toggle").click(function(){
    jQuery(".mobile-header-search").removeClass("active");  
  });
  /*################### Home Pages ######################*/
  /* Sticky Header */
  function sticky_section() {
    var header_h = jQuery('.site-header').height();
    jQuery(window).scroll(function(){
      var sticky = jQuery('.header-section'),
          scroll = jQuery(window).scrollTop();
      if (scroll >= 1){
        sticky.addClass('fixed');
        jQuery('body').addClass('fixed');
        jQuery('body').css('padding-top', header_h);
      }
      else {
        sticky.removeClass('fixed');
        jQuery('body').removeClass('fixed');
        jQuery('body').css('padding-top', '0');
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);

  /* Slick Slider */
  jQuery('.js-banner-slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    adaptiveHeight:true,
    prevArrow:'<button type="button" class="slick-prev"></button>',
    nextArrow:'<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: true,
        }
      }
    ]
  });
  
  jQuery('.js-pro-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      }
    ]
  });

  jQuery('.js-pro-slider-v2').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        }
      }
    ]
  });
  
  jQuery('.js-pro-slider-4').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev slider-border-left"></button>',
    nextArrow:'<button type="button" class="slick-next slider-border-right"></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1025, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows:false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows:false
        }
      }
    ]
  });
  
  jQuery('.js-logo-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    prevArrow:'<button type="button" class="slick-prev"></button>',
    nextArrow:'<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        }
      }
    ]
  });
  
  /* Image with text */
  function banner_home_section() {
    var body_width = jQuery('body').width();
    var header_wrapper = jQuery('.main-header .wrapper').width();
    var temp_width = body_width - header_wrapper; 
    var temp_width_2 = temp_width / 2;  
    jQuery(".block-list .block-item .block-content").css('padding-right', temp_width_2);
    jQuery(".collection-banner-text .collection-content").css('padding-right', temp_width_2);
    jQuery(".store-list .store-item.map_right").css('padding-left', temp_width_2);
    jQuery(".store-list .store-item.map_left").css('padding-right', temp_width_2);
    jQuery(".history-item:nth-child(odd) .history-content").css('padding-left', temp_width_2);
    jQuery(".history-item:nth-child(even) .history-content").css('padding-right', temp_width_2);
    
  }
  banner_home_section();
  jQuery(window).on('load resize orientationchange', banner_home_section);
  
  /*################### Product Page ################### */ 
  jQuery('.js-product-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    //centerMode: true,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
      }
    ]
  });
  
  /* Product Tab */
  jQuery('#product-tab ul.tabs li').click(function(){
    var tab_id = jQuery(this).attr('data-tab');
    jQuery('#product-tab ul.tabs li').removeClass('current');
    jQuery('#product-tab .tab-content').removeClass('current');
    jQuery(this).addClass('current');
    jQuery("#"+tab_id).addClass('current');
  });

  jQuery(".p-accordion-content").hide(); 
  jQuery(".p-accordion-title").click(function(){
    jQuery(this).toggleClass('active');
    if(jQuery(this).hasClass('active')){
      jQuery('.p-accordion-content').slideUp();
      jQuery('.p-accordion-title').not(this).removeClass('active');
      jQuery('.p-accordion-block').removeClass('activeToggle');
      jQuery(this).addClass('active');
      jQuery(this).next('.p-accordion-content').slideDown();
      jQuery(this).parent().addClass("activeToggle");
    } else {
      jQuery(this).removeClass('active');
      jQuery(this).next('.p-accordion-content').slideUp();
      jQuery(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn, .announcement-btn', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top - 200
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });
  
  /*################### Footer Accordion ################### */ 
  $(".f-accordion-content").hide(); 
  $(".f-accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.f-accordion-content').slideUp();
      $('.f-accordion-title').not(this).removeClass('active');
      $('.f-accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.f-accordion-content').slideDown();
      $(this).parent().addClass("activeToggle");
    } else {
      $(this).removeClass('active');
      $(this).next('.f-accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /*################### Brand Filter ################### */ 
  /*var triggers = $('.brand-filter a');
  var filters = $('.brand-list .brand-item .brand-title');

  triggers.click(function() {
    $(".all-link").removeClass('active');
    var takeLetter = $(this).text(), result = 0;
    filters.parent().hide();
    triggers.removeClass('active');
    $(this).addClass('active');
    $('#result').show();
    filters.each(function(i) {
      if ( RegExp('^'+takeLetter).test($(this).text()) ) {
        result += 1;
        $(this).parent().fadeIn(222);
      } 
    });
    $('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
    //if (result<1) {alert('There is no result.');}
  });

  $(".brand-filter .all-link").click(function(){
    $(this).addClass('active');
    filters.parent().show();
    triggers.removeClass('active');
    $('#result').hide();
  });
  */
}); 